import React from 'react';

/**
 * PROPS
 * value = string
 * label = string
 * onChange(value) = func
 */

// FIXME: Component duplicate <Input /> from ~c/ui/Input
const Input = props => {
  return (
    <React.Fragment>
      <label className="inp">
        <input autoComplete="off"
          placeholder=" "
          className={props.classes ? props.classes : 'inp__field'}
          type="text"
          value={props.value}
          onChange={e => props.onChange(e.target.value)}
          onBlur={e => props.onBlur(e.target.value)}
        />
        <p className="inp__label">{props.label ? props.label : ''}</p>
      </label>
    </React.Fragment>
  );
};

Input.defaultProps = {
  onChange: () => {},
  onBlur: () => {},
};

export default Input;
